(function () {
  if (window.__iagBackInStockKlaviyoInit) return;
  window.__iagBackInStockKlaviyoInit = true;

  function getCompanyId(container) {
    if (container?.dataset.klaviyoCompanyId) return container.dataset.klaviyoCompanyId;

    const scripts = document.querySelectorAll('script[src*="klaviyo"]');
    for (const script of scripts) {
      const fromQuery = script.src.match(/[?&]company_id=([^&]+)/);
      if (fromQuery) return decodeURIComponent(fromQuery[1]);

      const fromPath = script.src.match(/\/onsite\/js\/([A-Za-z0-9]{6})\/klaviyo\.js/);
      if (fromPath) return decodeURIComponent(fromPath[1]);
    }

    return null;
  }

  async function subscribeBackInStock({ companyId, email, variantId }) {
    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: { email },
            },
          },
          channels: ['EMAIL'],
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantId}`,
            },
          },
        },
      },
    };

    const response = await fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          revision: '2024-06-15',
        },
        body: JSON.stringify(payload),
      }
    );

    return response.status === 202;
  }

  function getMessage(container, selector, fallback) {
    return container.querySelector(selector)?.content.textContent.trim() || fallback;
  }

  function setStatus(container, type, message) {
    let status = container.querySelector('[data-back-in-stock-status]');

    if (!status) {
      status = document.createElement('p');
      status.dataset.backInStockStatus = 'true';
      status.className = 'form-status form-status-list form__message lh-15 mb-0';
      status.setAttribute('role', type === 'error' ? 'alert' : 'status');
      container.querySelector('form#back-in-stock-alert')?.appendChild(status);
    }

    status.textContent = message;
    status.hidden = false;
    status.classList.toggle('color-error', type === 'error');
  }

  function clearStatus(container) {
    const status = container.querySelector('[data-back-in-stock-status]');
    if (status) status.hidden = true;
  }

  function setSubmitting(form, isSubmitting) {
    const button = form.querySelector('[type="submit"]');
    const email = form.querySelector('[name="contact[email]"]');

    if (button) {
      button.disabled = isSubmitting;
      button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');
    }

    if (email) email.readOnly = isSubmitting;
  }

  function submitShopifyContactForm(form) {
    const action = form.getAttribute('action') || '/contact';
    const body = new FormData(form);

    fetch(action, {
      method: 'POST',
      body,
      credentials: 'same-origin',
    }).catch(() => {});
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('form#back-in-stock-alert');
      const container = form?.closest('[data-back-in-stock-form]');
      if (!form || !container) return;

      event.preventDefault();
      clearStatus(container);

      const companyId = getCompanyId(container);
      const email = form.querySelector('[name="contact[email]"]')?.value?.trim();
      const variantId =
        form.querySelector('[name="contact[Variant ID]"]')?.value ||
        form.querySelector('[id^="back-in-stock-variant-"]')?.value;

      const successMessage = getMessage(
        container,
        '[data-back-in-stock-success-message]',
        "Thank you. We'll let you know when it's back in stock."
      );
      const errorMessage = getMessage(
        container,
        '[data-back-in-stock-error-message]',
        'Unable to save your request. Please try again.'
      );

      if (!email) return;

      if (!companyId || !variantId) {
        setStatus(container, 'error', errorMessage);
        return;
      }

      setSubmitting(form, true);

      try {
        const subscribed = await subscribeBackInStock({ companyId, email, variantId });

        if (!subscribed) {
          setStatus(container, 'error', errorMessage);
          return;
        }

        setStatus(container, 'success', successMessage);
        submitShopifyContactForm(form);
      } catch (error) {
        setStatus(container, 'error', errorMessage);
      } finally {
        setSubmitting(form, false);
      }
    },
    true
  );
})();
